import 'css-chunksrc/client/scenes/attachDocuments/filesSystem/dropPreview/styles.scss';export default {
  "dropPreview": "_dropPreview_1u1ol_1",
  "icon": "_icon_1u1ol_17",
  "message": "_message_1u1ol_22"
};